import type { AdminSettingsStatus } from "../page";
interface CurrentSummaryCardProps {
    status: AdminSettingsStatus;
}
const CurrentSummaryCard = ({ status }: CurrentSummaryCardProps) => {
    const summaryRows = [
        { label: "관리자", value: status.admin?.name ?? "-" },
        { label: "로그인 ID", value: status.admin?.loginId ?? "-" },
        { label: "권한", value: status.admin?.roleType ?? "-" },
        { label: "계정 상태", value: status.admin?.status ?? "-" },
    ];
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-indigo-50">
          <i className="ri-user-settings-line text-indigo-600 text-xs"/>
        </div>
        <h4 className="text-xs font-semibold text-slate-700">현재 관리자</h4>
      </div>
      <div className="flex flex-col gap-2">
        {summaryRows.map((row) => (<div key={row.label} className="flex items-center justify-between gap-3">
            <span className="text-xs text-slate-500">{row.label}</span>
            <span className="text-xs font-medium text-slate-700 text-right truncate">{row.value}</span>
          </div>))}
      </div>
    </div>);
};
export default CurrentSummaryCard;
